export default __webpack_public_path__ + "static/media/photo--sm--44.447f2f6c.jpg";